import { clsx } from 'clsx'
import { ReactNode } from 'react'
import css from './HeaderAction.module.scss'

type Props = {
  icon: ReactNode
  label: ReactNode
  action?(): unknown
  href?: string
  bare?: boolean
  accent?: boolean
  badge?: ReactNode
  className?: string
}

export function HeaderAction({ icon, label, action, href, bare, accent, badge, className }: Props) {
  const content = <>
    <span className={clsx(css.tile, bare && css.bare, accent && css.accent)}>
      {icon}
      {badge != null && <span className={css.badge}>{badge}</span>}
    </span>
    <span className={css.label}>{label}</span>
  </>

  if (href) {
    return <a className={clsx(css.action, className)} href={href} target="_blank" rel="noopener">
      {content}
    </a>
  }

  return <button className={clsx(css.action, className)} type="button" onClick={() => void action?.()}>
    {content}
  </button>
}
